<ler-header />

<main class="ler-content">
  <router-outlet />
</main>

<accredible-cookies-banner />
